/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type FinAgentTypeService from 'embercom/services/fin-agent-type-service';

export default class FinAiAgentSalesRoute extends Route {
  @service declare finAgentTypeService: FinAgentTypeService;

  beforeModel() {
    this.finAgentTypeService.setCurrentAgentType('sales');
  }
}
